module.exports = __webpack_public_path__ + "static/media/facebook-volgers-dieet-club-1200.8dbf1891.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-volgers-dieet-club-1200.png
// module id = 191
// module chunks = 0